import type { Semantic } from "types/styled";

import { DARK_BLUE, WHITE } from "./colors";

export const semantic: Semantic = {
  background: {
    default: WHITE,
  },
  border: {
    default: DARK_BLUE[20],
  },
  container: {
    background: WHITE,
    border: `1px solid ${DARK_BLUE[10]}`,
  },
  spacing: {
    xxsm: "2px",
    xsm: "4px",
    sm: "8px",
    sm2: "12px",
    md: "16px",
    md2: "20px",
    lg: "24px",
    lg2: "28px",
    xl: "32px",
    xxl: "40px",
    xxxl: "48px",
  },
  zIndex: {
    navbar: 99,
    modal: 100,
    popup: 200,
  },
};
